module.exports = __webpack_public_path__ + "static/img/1.086c3a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/1.png
// module id = JNmI
// module chunks = 0